<template>
  <div class="logo-container">
    <transition enter-active-class="animate__animated animate__fadeInLeft">
      <div class="img-container">
        <img
          :src="userStore.userInfo?.logoUrl"
          alt=""
          class="title_class"
          v-if="appStore.sidebar.opened && userStore.userInfo?.logoUrl"
        />
        <img
          v-else-if="appStore.sidebar.opened"
          src="@/assets/images/logo.png"
          alt=""
          class="title_class"
        />
        <svg-icon icon-class="minilogo" class="minititle_class" v-else />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { useAppStore, useUserStore } from "@/stores";

const appStore = useAppStore();
const userStore = useUserStore();
function toggleSideBar() {
  appStore.toggleSidebar();
}

defineProps({
  collapse: {
    type: Boolean,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.logo-container {
  width: 100%;
  height: $navbar-height;
  // border-bottom: 1px solid #161d26;
  // background-color: #151c25;
  display: flex;
  align-items: center;
  justify-content: center;
  .img-container {
    width: 130px;
    height: 52px;
  }
  .title_class {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .minititle_class {
    width: 48px;
    height: 29px;
  }
}
</style>
